module.exports = __webpack_public_path__ + "img/hyundai_avante_md16.00eec00a.jpg";